<template>
  <div class="branches_table grey loading_table">
    <b-loading :is-full-page="false" :active="isLoading"></b-loading>
    <b-table
      default-sort="name"
      ref="table"
      pagination-simple
      per-page="15"
      :data="filesList"
      paginated
      :checkable="userRole !== 'user'"
      :checked-rows.sync="rows.checked"
      @page-change="changePage"
      @sort="initSort"
      backend-sorting
      detailed
      :show-detail-icon="false"
      @click="openInfo"
    >
      <template slot-scope="props">
        <b-table-column
          label="Название"
          :visible="true"
          field="name"
          :centered="false"
          sortable
          :width="userRole === 'user' ? '65%' : '60%'"
        >
          <div>{{ props.row.name }}</div>
        </b-table-column>
        <b-table-column label="Размер" :visible="true" field="size" :centered="false" sortable width="15%">
          <div>{{ props.row.size }}</div>
        </b-table-column>
        <b-table-column label="Ссылка на файл" :visible="true" :centered="false" width="20%">
          <div><a target="_blank" :href="config.baseUrl + props.row.url">Ссылка на файл</a></div>
        </b-table-column>
      </template>

      <template slot="detail" slot-scope="props">
        <div class="table_actions">
          <button class="restore_course" @click="$emit('delete', props.row)">
            <i class="mdi mdi-folder-remove"></i>Удалить
          </button>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import { config } from '@/config'

export default {
  props: {
    filesList: {
      default: () => [],
      type: Array
    },
    rows: {
      default: () => {},
      type: Object
    },
    isLoading: {
      default: () => true,
      type: Boolean
    }
  },
  data() {
    return {
      openedRow: {}
    }
  },
  computed: {
    userRole() {
      return this.$store.state.auth.role[0]
    },
    config() {
      return config
    }
  },
  methods: {
    initSort(fieldName, sortType) {
      this.$emit('init-sort', fieldName, sortType)
    },
    openInfo(row) {
      if (row != this.openedRow) {
        this.$refs.table.toggleDetails(this.openedRow)
        this.$refs.table.toggleDetails(row)
        this.openedRow = row
        return
      }
      this.$refs.table.toggleDetails(row)
      this.openedRow = {}
    },
    changePage(val) {
      this.$emit('changePage', val)
    },
    sortSize(a, b, isAsc) {
      let aSize = a.size.slice(0, -2)
      let bSize = b.size.slice(0, -2)
      if (a.size.includes('МБ')) aSize = aSize * 1024
      if (b.size.includes('МБ')) bSize = bSize * 1024
      if (!isAsc) return bSize - aSize
      return aSize - bSize
    }
  }
}
</script>
